import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PrimaryAddress } from 'src/app/core';

@Component({
  selector: 'app-format-address-mx',
  templateUrl: './format-address-mx.component.html',
  styleUrls: ['./format-address-mx.component.less'],
})
export class FormatAddressMxComponent implements OnInit {
  inlineAddress: string;
  _address: PrimaryAddress;

  @Input() displayInline: boolean;
  @Input() country: string;
  @Input() set address(value: PrimaryAddress) {
    this._address = value;
  }
  get address() {
    return this._address;
  }
  @Output('onAddressChange')
  onAddressChange: EventEmitter<string> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
    this._setInlineAddress();
  }

  private _setInlineAddress() {
    if (this.address) {
      this.inlineAddress = this.address.address1;
      if (!this.address.address2 && !this.address.address3) {
        this.inlineAddress = `${this.inlineAddress}\n`;
      }
      if (this.address.address2) {
        this.inlineAddress = `${this.inlineAddress} ${this.address.address2},`;
      }
      if (this.address.address2 && !this.address.address3) {
        this.inlineAddress = `${this.inlineAddress}\n`;
      }
      if (this.address.address3) {
        this.inlineAddress = `${this.inlineAddress} Int.${this.address.address3}\n`;
      }
      if (this.address.description) {
        this.inlineAddress = `${this.inlineAddress}${this.address.description}\n`;
      }
      if (this.address.neighborhood) {
        this.inlineAddress = `${this.inlineAddress}${this.address.neighborhood}\n`;
      }
      if (this.address.postalCode) {
        this.inlineAddress = `${this.inlineAddress}${this.address.postalCode}\n`;
      }
      if (this.address.city) {
        this.inlineAddress = `${this.inlineAddress}${this.address.city}`;
      }
      if (this.address.state) {
        this.inlineAddress = `${this.inlineAddress}, ${this.address.state}\n`;
      }
      if (this.country) {
        this.inlineAddress = `${this.inlineAddress}${this.country}`;
      }
      this.onAddressChange.emit(this.inlineAddress);
    }
  }
}
